import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import PrivateRoutes from './routes/PrivateRoutes';
import { Provider } from 'react-redux';
import { store } from './redux/store'
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import ErrorPage from './components/ErrorPage';
import LandingPage from './components/LandingPage/LandingPage'
import { Typography } from '@mui/material';
import MainContent from './components/MainContent/MainContent';
import { PowerBiReports } from './components/Reports/PowerBiReports';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ConstructionIcon from '@mui/icons-material/Construction';

// const msalInstance = new PublicClientApplication(msalConfig);
// await msalInstance.initialize();

document.title = process.env.REACT_APP_PAGE_TITLE;

const observerError = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener( "error", ( e ) => {
  if ( e.message === observerError ) {
    e.stopImmediatePropagation();
  }
} );

const router = createBrowserRouter( [
  {
    path: "/",
    element: (
      // <Provider store={ store }>
      <App />
      // </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, loader: landingCards, element: <LandingPage /> },
      {
        path: "supply-planning",
        loader: customLoader,
        element: <PowerBiReports />,
      },
      {
        path: "inventory-optimization",
        loader: ioCards,
        element: <LandingPage />
      },
    ],
  },

] );

const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
  <React.StrictMode>
    {/* <MsalProvider instance={msalInstance}>
    </MsalProvider> */}
    <RouterProvider router={ router } />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

async function landingCards() {
  return [
    {
      id: 1,
      appCode: "MP",
      title: "Material Planning",
      disabled: false,
      url: process.env.REACT_APP_MATERIAL_PLANNING_URL,
      className: 'material-planning'
    },
    {
      id: 2,
      appCode: "DP",
      title: "Demand Planning",
      url: process.env.REACT_APP_DEMAND_PLANNING_URL,
      disabled: false,
      className: 'demand-planning'
    },
    {
      id: 3,
      appCode: "CT",
      title: "Command Center",
      url: process.env.REACT_APP_COMMAND_CENTER_URL,
      disabled: false,
      className: 'control-tower'
    },
    {
      id: 4,
      appCode: "Supply Planning",
      title: "Supply Planning",
      url: '/supply-planning',
      disabled: false,
      className: 'sp'
    },
    {
      id: 5,
      appCode: "IO",
      title: "Inventory Optimization",
      url: 'inventory-optimization',
      disabled: false,
      className: 'io'
    }
  ]
}

async function ioCards() {
  return [
    {
      id: 1,
      appCode: "ssa",
      title: "Safety Stock Approval",
      disabled: false,
      url: process.env.REACT_APP_SSA_URL,
      className: 'ssa'
    },
    {
      id: 2,
      appCode: "kpi",
      title: "KPI Metrices",
      url: process.env.REACT_APP_KPI_URL,
      disabled: false,
      className: 'kpi'
    }
  ]
}

async function customLoader() {
  return [
    {
      id: 's4',
      name: 'DQ S4',
      icon: <ConstructionIcon />,
      rules: [
        { name: 'Recipe  - Labor run rate' },
        { name: 'Recipe  - runrate vs qty' },
        { name: 'Production version' },
        { name: 'Prod resource' },
        { name: 'Plant KIT BOM extraction check' },
        { name: 'External Source of Supply Check' },
        { name: 'Production version - locking status & Date' },
        { name: 'Component coefficient qty' },
        { name: 'Material Classification' },
      ],
    },
    {
      id: 'ibp',
      name: 'DQ IBP',
      icon: <AutoModeIcon />,
      rules: [
        {
          name: 'Source of Supply check'
        },
        {
          name: 'Source of Supply check'
        },
        {
          name: 'No Lead time Check'
        },
        {
          name: 'No PSH Check'
        },
        {
          name: 'No PSS check'
        },
        {
          name: 'PSH Qty check - Min vs Capa'
        },
        {
          name: 'PSH Qty check - Max vs Capa'
        },
        {
          name: 'PSH Qty check - Rounding vs Capa'
        },
        {
          name: 'PSH Qty check -Max too low check'
        },
        {
          name: 'PSH Qty check -Min too high check'
        },
        {
          name: 'Subnetwork Check'
        },
        {
          name: 'IO Forecast check'
        },
        {
          name: 'Bev Product code check'

        },
        {
          name: 'Component Coefficient check'
        },
      ]
    },
    {
      id: 'kpi',
      name: 'KPI Metrices',
      icon: <AutoModeIcon />,
      rules: [
        { name: 'Parameter Adherence (past trend) – at aggregated level with drill downs (Top 10 SKUs min and max stock violation; Minimum stock violation drill down; Maximum stock violation drill down)' },
        { name: 'Fill Rate Adherence – % of kits on target (based on Service Level assigned due to segmentation strategy)' },
        { name: 'Inventory WO – Associated with sales, OU, not CPS' },
        { name: 'Forecast Accuracy at Kit Level' },
        { name: 'Inventory, forward looking (incident): Total current/projected stock vs. Target max inventory position' },
        { name: 'Safety stock adherence' },
        { name: 'Lot size adherence' },
        { name: 'Lead time adherence * within Materials Planning Workstream Analytics' },
        { name: 'Safety Stock composition per source - % Count of Materials' },
        { name: 'Safety Stock composition per source - % Value of Safety Stock' },
        { name: 'Safety Stock Value difference: IO Recommendation vs Final SS' },
        { name: 'Count of Safety Stock Master Data changes made directly in S4, by date and user' },
        { name: 'IBP IO Process Tracker per Plant -- TO BE REVIEWED ' },
      ]
    }
  ]
}